const defaultText = {
    tokensShortName: "tk",
    error_network_error: "Network error",
    // error_unknown_error: "Unknown error",
    common_info_dialog_login_warning_caption: "Please Log in\nor Create free account",
    common_info_dialog_login_warning_action_button: "Log in",
    common_info_dialog_favorites_login_warning_description: "Log in to sync your favorites across all\nyour devices",
    common_info_dialog_purchases_login_warning_description: "Log in now to access\nyour Purchased videos",
    common_info_dialog_favorites_no_models_warning_caption: "You have no Models in\nFavorites",
    common_info_dialog_favorites_no_models_warning_description: "Add models for quick and easy access\nto all your favorites in one spot!",
    common_info_dialog_favorites_no_models_warning_action_button: "Back to All Models",
    common_info_dialog_no_purchases_warning_caption: "No Purchased videos yet",
    common_info_dialog_no_purchases_warning_description: "Unlock exclusive content and support\nyour favorite models directly by\npurchasing their videos today!",
    common_info_dialog_no_purchases_warning_action_button: "Back to All Videos",
    common_info_dialog_top_up_warning_caption: "Уou need to top up\nyour balance",
    common_info_dialog_top_up_warning_description: "",
    common_info_dialog_top_up_warning_action_button: "Get tokens",
    common_info_dialog_messenger_no_messages_warning_caption: "No messages yet",
    common_info_dialog_messenger_no_messages_warning_description: "Send a DM in the model's room",
    common_info_dialog_messenger_no_messages_warning_action_button: "OK",
    common_player_error_invalid_token: "Oops! Couldn't start the Passthrough. Please try again in a bit",
    common_feature_pt_error_unavailable: "PT isn’t supported or AR mode is disabled",
    common_player_error_passthrough_stopped: "PassThrough has been stopped for this stream for technical reasons.",
    common_player_error_stream_difficulties: "Stream having tech issues. Check your connection or try another stream.",
    common_messenger_ellipsis_menu_view_profile: "View Profile",
    common_messenger_ellipsis_menu_private_show_options: "Private Show Options",
    common_messenger_ellipsis_menu_add_to_favorites: "Add to Favorites",
    common_messenger_ellipsis_menu_remove_from_favorites: "Remove from Favorites",
    common_messenger_ellipsis_menu_goto_room: "Go to Model’s Room",
    common_messenger_warning_no_messages_caption: "No messages yet",
    common_messenger_warning_no_messages_description: "Start the conversation",
    common_messenger_chatlist_caption: "All messages",
    common_messenger_new_messages_caption: "New Messages",
    common_messenger_model_status_privateShow: "PRIVATE",
    common_messenger_model_status_banned_user: "last seen a long time ago",
    common_messenger_model_status_typing: "typing...",
    common_messenger_model_status_online: "last seen recently",
    common_messenger_model_status_offline_delay_in_minutes: "last seen {0} minute{1} ago",
    common_messenger_model_status_offline_delay_in_hours: "last seen {0} hour{1} ago",
    common_messenger_model_status_offline_delay_in_days: "last seen {0} day{1} ago",
    common_messenger_model_status_offline_delay_in_months: "last seen {0} month{1} ago",
    common_messenger_input_placeholder: "Message",
    common_messenger_input_placeholder_muted: "You’ve been silenced.\nTip the model ‒ you might get unmuted!",
    common_messenger_input_placeholder_banned: "Chat is not available",
    common_messenger_chatlist_banned: "Chat is not available",
    common_messenger_chatlist_draft: "<rt color=\"{0}\">Draft:</rt> {1}",
    common_messenger_chatlist_tips: "You sent {0} tk",
    common_messenger_chatlist_tips_richtext: "<rt color=\"{0}\">You sent {1} tk</rt>",
    common_messenger_chatlist_no_messages: "No messages yet",
    common_messenger_quick_messages: ["Hi", "HRU?", "PVT?", "Thanks", "Great!", "Yes", "No"],
    common_messenger_error_authorized_failed: "Private Messenger authorization failed",
    // common_messenger_error_websocket_connection_failed: "Private Messenger connection failed",
    common_messenger_error_message_not_sent: "Not sent. Please try again.",
    common_messenger_link_warning_caption: "Attention!",
    common_messenger_link_warning_text: "Leaving our platform via external\n" +
        "links is at your own discretion.\n" +
        "\n" +
        "Clicking “Proceed”\n" +
        "will exit VR mode.",
    common_messenger_link_warning_proceed_button: "Proceed",
    common_messenger_link_warning_cancel_button: "Cancel",
    lobby_signIn: "Log in",
    lobby_signUp: "Sign up",
    lobby_signInSignUp: "Log in\nSign up",
    lobby_signOut: "Sign out",
    lobby_signInCaps: "LOG IN",
    lobby_signUpCaps: "SIGN UP",
    lobby_signOutCaps: "SIGN OUT",
    lobby_topUp: "Get tokens",
    lobby_topUpHint: "Proceed\nin browser",
    lobby_exitVr: "Exit VR",
    lobby_username: "Username", //todo
    lobby_password: "Password",
    lobby_incorrectUsernameOrPassword: "Incorrect username or password", //todo
    lobby_upcomingEvents: "UPCOMING EVENT",
    lobby_tags_header: "CATEGORIES",
    lobby_mode_live: "Live",
    lobby_mode_videos: "Videos",
    lobby_live_categories_header: "Categories",
    lobby_live_tags_noTagGroupsDescription: "No more additional categories.\nClear categories to see more",
    lobby_live_tags_clearTagGroupsButton: "Clear categories",
    lobby_video_tags_header: "Categories",
    // lobby_video_tags_purchases_description: "Enjoy watching!",
    lobby_tags_clear_all_button: "Clear all",
    lobby_tabs_live_all_models: "All models",
    lobby_tabs_live_favorites: "Favorites",
    lobby_tabs_videos_all_videos: "All videos",
    lobby_tabs_videos_purchased: "Purchased",
    lobby_models_header: "Models",
    lobby_models_videos_label: "videos",
    lobby_model_info_goto_online_broadcast_button: "Watch Live Show",
    lobby_model_info_goto_offline_broadcast_button: "Enter My Room",
    lobby_gallery_item_status_away: "AWAY",
    lobby_gallery_item_status_live: "LIVE",
    lobby_gallery_item_status_privateShow: "IN PRIVATE",
    lobby_gallery_item_status_offline: "OFFLINE",
    lobby_gallery_item_spy_now: "SPY NOW",
    lobby_gallery_item_free: "FREE",
    lobby_gallery_item_purchased: "PURCHASED",
    lobby_gallery_item_purchased_with_date: "PURCHASED {0}",
    lobby_upcoming_event_status_live: "WATCH NOW",
    lobby_userPanel_recenter: "Recenter",
    lobby_userPanel_help: "How-to guides",
    lobby_userPanel_environment: "Environment",
    lobby_userPanel_exitVR: "Exit VR",
    lobby_userPanel_signout: "Sign out",
    lobby_userPanel_signin: "Log in",
    lobby_userPanel_signup: "Create free account",
    broadcast_broadcastIsNotLive: "The broadcast is not live at this moment",
    broadcast_broadcastCannotBeOpened: "The broadcast cannot be opened",
    broadcast_broadcastPermanentlyBlocked: "You are currently blocked by {0}",
    broadcast_broadcastTemporarilyBlocked: "You have been temporarily blocked by {0} for {1}",
    broadcast_userIsMuted: "You are muted in this chat, but you can still tip and request Private Shows",
    broadcast_maintenanceIsInProgress: "Maintenance is in progress.\nTry again in several minutes.",
    broadcast_menu_unauthorizedUserNickname: "guest",
    broadcast_menu_exitVr: "Exit VR",
    broadcast_menu_navigation_volume: "Volume",
    broadcast_menu_navigation_stream_2D: "2D stream",
    broadcast_menu_navigation_stream_3D: "VR stream",
    broadcast_menu_navigation_stream_3D_6K: "6K VR stream",
    broadcast_menu_subtitles_placeholder: "Live captions",
    broadcast_menu_tipMenu_startButton: "Tip Menu",
    broadcast_menu_tipMenu_panelCaption: "Tip Menu",
    broadcast_menu_tipMenu_tipsColumnHeader1: "ACTIVITY",
    broadcast_menu_tipMenu_tipsColumnHeader2: "TOKENS",
    broadcast_menu_tipMenu_toysColumnHeader1: "VIBRATION",
    broadcast_menu_tipMenu_toysColumnHeader2: "DURATION",
    broadcast_menu_tipMenu_toysColumnHeader3: "TOKENS",
    broadcast_menu_tipMenu_activitiesButton: "Activities",
    broadcast_menu_tipMenu_toysButton: "Toys",
    broadcast_menu_tipMenu_tipMenuDisabled: "Please tell me what I can do for you via chat!",
    broadcast_menu_tipMenu_tipMenuEmpty: "Please tell me what I can do for you via chat!",
    broadcast_menu_tipMenu_toysDurationIsZero: "—",
    broadcast_menu_tipMenu_toysDurationIsNonZero: "{0}s",
    broadcast_menu_tipMenu_toysPriceNoMax: "≥{0}",
    broadcast_menu_tipMenu_toysPriceSameMinMax: "{0}",
    broadcast_menu_tipMenu_toysPriceInterval: "{0}-{1}",
    broadcast_menu_tipMenu_message_signIn_text: "Please Log in or\nCreate free account",
    broadcast_menu_tipMenu_message_signIn_button: "Log in / Sign up",
    broadcast_menu_tipMenu_message_topUp_text: "Уou need to top up\nyour balance",
    broadcast_menu_tipMenu_message_topUp_button: "Get tokens",
    broadcast_menu_tipMenu_message_confirmLeave_text: "Stop Private Show?",
    broadcast_menu_tipMenu_message_confirmLeave_button: "Stop",
    broadcast_menu_tipMenu_message_privateShow_text: "Available in Private\nShows only",
    broadcast_menu_tipMenu_message_privateShow_textChat_line1: "Text chat",
    broadcast_menu_tipMenu_message_privateShow_textChat_line2: "from {0} min, can Spy",
    broadcast_menu_tipMenu_message_privateShow_voiceChat_line1: "Voice chat",
    broadcast_menu_tipMenu_message_privateShow_voiceChat_line2: "from {0} min, no Spy",
    broadcast_menu_tipMenu_message_privateShow_price: "{0}tk/min",
    broadcast_menu_tipMenu_message_privateShow_button: "Choose your Private Show",
    broadcast_menu_tipMenu_message_purchase_text: "Send tip",
    broadcast_menu_tipMenu_message_purchase_button: "Send",
    broadcast_menu_tipMenu_chatMessage_line1: "{0} sent {1} tk",
    broadcast_menu_tipMenu_chatMessage_line2: "TIP MENU: {0}",
    broadcast_menu_tipMenu_chatMessage_toyChatMessageZeroDuration: "{0} vibration.\nPlay with it {1} to make me cum!",
    broadcast_menu_tipMenu_chatMessage_toyChatMessageNonZeroDuration: "{0} vibration for {1} sec.\nPlay with it {2} to make me cum!",
    broadcast_menu_tipMenu_toyTip_header: "Send Tip",
    broadcast_menu_tipMenu_toyTip_button: "Send",
    broadcast_menu_tipMenu_toyTip_priceTextNoMax: "Price: ≥{0} tk",
    broadcast_menu_tipMenu_toyTip_priceTextSameMinMax: "Price: {0} tk",
    broadcast_menu_tipMenu_toyTip_priceTextInterval: "Price: {0} tk – {1} tk",
    broadcast_menu_tipMenu_toyTip_modeTextZeroDuration: "{0} vibration",
    broadcast_menu_tipMenu_toyTip_modeTextNonZeroDuration: "{0} vibration {1}s",
    broadcast_menu_tipMenu_emptyPanel_activities_line1: "There are currently\nno Activities",
    broadcast_menu_tipMenu_emptyPanel_activities_line2: "Please check again later\nor ask {0} to fill it in for you!",
    broadcast_menu_tipMenu_emptyPanel_toys_line1: "Toys menu\nis currently empty",
    broadcast_menu_tipMenu_emptyPanel_toys_line2: "Please check again later\nor ask {0} to fill it in for you!",
    broadcast_menu_tips_header: "SEND TIPS",
    // broadcast_menu_tips_sendTip: "Send tip",
    broadcast_menu_tips_confirmSendDialog_confirm: "Send",
    broadcast_menu_tips_confirmSendDialog_reject: "Cancel",
    broadcast_menu_tips_emptyValue: "•••",
    broadcast_menu_guestTitle: "Guest mode",
    broadcast_menu_warning_nonAuthorizedUser: "You need to Log in",
    broadcast_menu_warning_notEnoughTokens: "You need to top up your balance",
    broadcast_menu_warning_underConstruction: "Under construction",
    broadcast_menu_clientBalance_balance: "Balance",
    broadcast_menu_clientBalance_tokens: "tk",
    broadcast_menu_chat_tip: "{0} has tipped {1} tk",
    broadcast_menu_chat_customTip: "Custom tip",
    broadcast_menu_chat_placeholder: "Make the first move…",
    broadcast_menu_chat_placeholder_spy: "Chat is unavailable in Spy Show",
    // broadcast_menu_chat_somethingWentWrong: "Oops! Something went wrong. Brace yourself until we get the error fixed.",
    broadcast_menu_chat_voiceToText_header: "Tired of typing with Controller?\nTry Voice-to-Text!",
    broadcast_menu_chat_voiceToText_line1: "• Tap and Hold the microphone icon as you speak",
    broadcast_menu_chat_voiceToText_line2: "• When you’re done, Send your text to the chat",
    broadcast_menu_chat_voiceToText_dontShow: "Don’t show again",
    broadcast_menu_chat_voiceToText_ok: "OK",
    broadcast_menu_chat_voiceToText_error: "Please check that your\nheadset's microphone is\nturned on and allow access",
    broadcast_menu_chat_voiceToText_animationPanelHeader: "Speak",
    broadcast_menu_chat_voiceToText_animationPanelLoadingHeader: "Loading",
    broadcast_menu_chat_toysMenuNotification: "Make models cum by controlling their\ntoys from anywhere in the world!",
    // broadcast_menu_privateShow_primaryInfo: "Model will chat exclusively with you.\nNo one else can see your chat.",
    broadcast_menu_privateShow_tokensPerMin: "tokens\nper minute",
    broadcast_menu_privateShow_minutesMin: "minutes\nminimum",
    broadcast_menu_privateShow_enterPrivateShowButton_buttonText: "Start Private Show",
    broadcast_menu_privateShow_enterPrivateShowButton_line1: "Start",
    broadcast_menu_privateShow_canCancelPrivateShowRequestPanel_line1: "Private Show",
    broadcast_menu_privateShow_canCancelPrivateShowRequestPanel_line2: "Request has been sent",
    broadcast_menu_privateShow_canCancelPrivateShowRequestPanel_cancelPrivateShowRequestButton: "Cancel request",
    broadcast_menu_privateShow_canStopPrivateShowPanel_line1: "Private Show",
    broadcast_menu_privateShow_canStopPrivateShowPanel_line2: "Active",
    broadcast_menu_privateShow_canStopPrivateShowPanel_stopPrivateShowButton: "Stop",
    broadcast_menu_privateShow_canStopSpyShowPanel_line1: "You are currently in Spy Show",
    broadcast_menu_privateShow_canStopSpyShowPanel_line2: "Active",
    broadcast_menu_privateShow_canStopSpyShowPanel_stopSpyShowButton: "Stop",
    broadcast_menu_privateShow_cancelPrivateShowRequestPanel: "Your request has been sent",
    broadcast_menu_privateShow_cancelPrivateShowRequestButton: "Cancel",
    broadcast_menu_privateShow_inTextPrivateShow: "You are in a Classic Private Show",
    broadcast_menu_privateShow_inAudioPrivateShow: "You are in a Full Immersion Private Show",
    broadcast_menu_privateShow_leavePrivateShowButton: "Stop",
    broadcast_menu_privateShow_confirmLeaveButton: "Leave",
    broadcast_menu_privateShow_confirmLeaveText: "Are you sure you want\nto leave the Private Show?",
    broadcast_menu_privateShow_leaveWarning: "If you wish to exit, please leave this Private Show",
    broadcast_menu_privateShow_privateShowRefusedByModel: "Your Private Show request has been declined by Model",
    broadcast_menu_privateShow_privateShowStarted: "Your Private Show has started",
    broadcast_menu_privateShow_privateShowStopped: "Your Private Show has ended",
    broadcast_menu_privateShow_privateShowStoppedByModel: "Private Show was stopped by Model",
    broadcast_menu_privateShow_privateShowStoppedByBilling: "Private Show was stopped due to insufficient funds.\nPlease top up balance",
    broadcast_menu_privateShow_privateShowCanceledDueToTechnicalReasons: "Private Show was stopped due to technical reasons",
    broadcast_menu_privateShow_privateModePanel: {
        line1: "Private Show",
        line2: "Choose text or voice options"
    },
    broadcast_menu_privateShow_privateModePanelHeader: "Choose your Private Show",
    broadcast_menu_privateShow_audioPrivateMode: {
        header: "Full Immersion",
        featureList: ["No Spies", "Voice Chat", "Text Chat", "Tip Menu"],
        priceUnits: "/ min",
        minDuration: "Minimum time: {0} mins",
        buttonText: "Invite",
    },
    broadcast_menu_privateShow_textPrivateMode: {
        header: "Classic",
        featureList: ["Text Chat", "Tip Menu"],
        priceUnits: "/ min",
        minDuration: "Minimum time: {0} mins",
        buttonText: "Invite",
    },
    // broadcast_menu_spyMode_availableInfoLine1: "Peek at some spicy moments of the Show. Spy NOW",
    broadcast_menu_spyMode_availableInfoLine3: "/ min",
    broadcast_menu_spyMode_unavailableInfoLine1: "Model is having fun in the Private Show",
    broadcast_menu_spyMode_unavailableInfoLine2: "Spying is not available for this Private Show",
    broadcast_menu_spyMode_spyModeStarted: "You are Spying now",
    broadcast_menu_spyMode_spyModeStopped: "You have stopped Spying on {0}'s Private Show",
    broadcast_menu_spyMode_spyModeStoppedByBilling: "You don't have enough tokens to continue Spying. Please top up balance.",
    broadcast_menu_spyMode_spyModeStoppedByTechReasons: "The Spy session was stopped due to technical reasons",
    broadcast_menu_spyMode_enterSpyModeButton: "Spy NOW",
    broadcast_menu_spyMode_leaveSpyModeButton: "Stop",
    broadcast_menu_spyMode_confirmLeaveButton: "Stop",
    broadcast_menu_spyMode_confirmLeaveText: "Are you sure you want\nto end your Spy Show?",
    broadcast_menu_spyMode_leaveWarning: "If you wish to exit, please leave this Spy Show",
    broadcast_menu_modelPanel_viewProfile: "View Profile",
    broadcast_menu_modelPanel_hideProfile: "Hide Profile",
    broadcast_menu_modelPanel_lockText: "Log in to Unlock",
    broadcast_menu_modelPanel_profilePanel_age: "{0} years old",
    broadcast_menu_modelPanel_profilePanel_birthday: "Birthday Today • {0} years",
    broadcast_menu_modelPanel_profilePanel_bio: "Bio",
    broadcast_menu_modelPanel_profilePanel_check_videos: "Check my Videos",
    broadcast_menu_modelPanel_profilePanel_posts: "Posts",
    broadcast_menu_modelPanel_profilePanel_profile: "Profile",
    broadcast_menu_modelPanel_profilePanel_info: "Info",
    broadcast_menu_modelPanel_profilePanel_location: "Location",
    broadcast_menu_modelPanel_profilePanel_appearance: "Appearance",
    broadcast_menu_modelPanel_profilePanel_mySpecifics: "My specifics",
    broadcast_menu_modelPanel_profilePanel_thingsIDo: "I do in my shows",
    broadcast_menu_modelPanel_profilePanel_thingsIDoPrivate: "I only do in Private Shows",
    broadcast_menu_modelPanel_profilePanel_hobbies: "Passions and hobbies",
    broadcast_menu_modelPanel_profilePanel_schedule: "Schedule",
    broadcast_menu_modelPanel_profilePanel_viewMore: "View More",
    broadcast_menu_helpPanel_header: "How-to guides",
    broadcast_menu_helpPanel_intro: "Ready to explore?\nLet’s dive in.",
    broadcast_menu_helpPanel_drag_header: "Drag & drop",
    broadcast_menu_helpPanel_drag_text: "Pull and hold\nthe  <rt backgroundColor='{0}' backgroundRadius='{1}' backgroundPadding='H{2}V{3}' fontWeight='{4}'>Trigger</rt>  on\nthe bottom bar to\nmove around the menu.",
    broadcast_menu_helpPanel_zoom_header: "Zoom in/out",
    broadcast_menu_helpPanel_zoom_text: "Move the  <rt backgroundColor='{0}' backgroundRadius='{1}' backgroundPadding='H{2}V{3}' fontWeight='{4}'>Thumbstick</rt>\nup and down to zoom\nin and out.",
    broadcast_menu_helpPanel_close_header: "Close menu",
    broadcast_menu_helpPanel_close_text: "Pull and release\nthe  <rt backgroundColor='{0}' backgroundRadius='{1}' backgroundPadding='H{2}V{3}' fontWeight='{4}'>Trigger</rt>\nanywhere outside\nthe menu to close.",
    broadcast_menu_helpPanel_controller_select: "Select",
    broadcast_menu_helpPanel_controller_lobby: "Enter\nthe Lobby",
    broadcast_menu_helpPanel_controller_tip: "Send\na Custom Tip",
    broadcast_menu_helpPanel_controller_drag: "Drag & drop",
    broadcast_menu_helpPanel_controller_prev_next: "Previous/Next Model",
    broadcast_menu_helpPanel_controller_zoom: "Zoom in/out",
    broadcast_menu_helpPanel_controller_reset: "Reset zoom",
    broadcast_menu_helpPanel_controller_recenter: "Recenter",
    broadcast_menu_helpPanel_controller_long_press: "long press",
    videoClip_menu_helpPanel_controller_play_pause: "Play/Pause",
    videoClip_menu_helpPanel_controller_forward_rewind: "Fast Forward/Rewind",
    broadcast_menu_relatedPanel_header: "Related Streams",
    broadcast_menu_relatedPanel_caption: "No Related Streams",
    broadcast_menu_relatedPanel_description: "See who’s live now by visiting the lobby",
    videoClip_lockedVideoCover_leaveButton: "Back to All Videos",
    videoClip_lockedVideoCover_buyButton: "Buy",
    videoClip_lockedVideoCover_cancelButton: "Cancel",
    videoClip_lockedVideoCover_finalLine1: "Thank you",
    videoClip_lockedVideoCover_finalLine2: "Enjoy your video!",
    videoClip_menu_main_live_show: "Watch Live Show",
    videoClip_menu_main_offline_show: "Enter My Room",
    videoClip_menu_info_caption: "Information",
    // videoClip_menu_info_watch_show: "Watch Live Show",
    videoClip_menu_info_published_at: "Published {0}",
    videoClip_recommended_title: "You might like",
    broadcast_backupPicture_streamed_live_minutes_delay: "Streamed live {0} minute{1} ago",
    broadcast_backupPicture_streamed_live_hours_delay: "Streamed live {0} hour{1} ago",
    broadcast_backupPicture_streamed_live_days_delay: "Streamed live {0} day{1} ago",
    broadcast_backupPicture_streamed_live_months_delay: "Streamed live {0} month{1} ago",
    broadcast_backupPicture_info_line_1_offline: "Sorry, {0} is currently offline but will be back again soon.",
    broadcast_backupPicture_info_line_1_away: "Sorry, {0} is away right now but will be online again very soon.",
    broadcast_backupPicture_info_line_1_private_show: "{0} is currently in a Private Show. Don’t feel left out.",
    broadcast_backupPicture_info_line_2_offline: "",
    broadcast_backupPicture_info_line_2_away: "Stay close by!",
    broadcast_backupPicture_info_line_2_private_show: "",
    broadcast_backupPicture_info_line_3: "Meanwhile, we have a lot of other stunning models online.",
    broadcast_backupPicture_leave_room_button: "Check them out!",
    broadcast_backupPicture_start_spy_show_button: "Spy NOW!",
    broadcast_backupPicture_nickname_stub: "Model",
    broadcast_complimentDialog_header: "Private Show has finished",
    broadcast_complimentDialog_message: "Thank you for the fantabulous time",
    broadcast_complimentDialog_request: "If you enjoyed the show I would\nreally appreciate a compliment…",
    broadcast_complimentDialog_buttonHeader: "Show me your love!",
    broadcast_complimentDialog_placeholder: "Custom",
    broadcast_complimentDialog_payButton: "Compliment",
    broadcast_complimentDialog_tokens: "{0} tk",
    broadcast_complimentDialog_percentage: "{0}%",
    broadcast_complimentMessageDialog_success: "Thank you\nHope to see you again soon!",
    broadcast_complimentMessageDialog_fail: "Sorry, something went wrong.\n Try again next time",
    broadcast_loader_next: "Next Model",
    broadcast_loader_previous: "Previous Model",
    broadcast_loader_recenter: "Recentering",
    broadcast_loader_lobby: "Entering the Lobby",
    broadcast_loader_tip: "Sending a Custom Tip",
    broadcast_controller_tip_error: "Please enter a custom tip amount",
    broadcast_controller_tip_error_on_opened_messenger: "Controller tipping is blocked while the chat window is up",
    onboarding_nextButton: "Next",
    onboarding_finishButton: "Let's explore!",
    onboarding_slides: [
        {
            text: "Your pleasure is our top priority.\nExperience full immersion by\nfollowing these simple steps.",
            header: "Welcome\nto Dreamcam!"
        },
        {
            text: "Click on the model’s\nprofile photo to enter the\nroom."
        },
        {
            text: "Talk to your dream model\nby typing in the chat..."
        },
        {
            text: "... or start a Private Show\nand share your deepest\ndesires!"
        },
        {
            text: "Save and easily return to\nyour most liked models."
        },
        {
            text: "Exchange direct\nmessages with models!"
        },
        {
            text: "Lastly, don’t forget to\nshow your affection by\nsending tips."
        },
    ],
    featureAnnouncement_button: "OK",
    featureAnnouncement_slides: [
        {
            text: "",
            header: "What's new",
        },
    ],
    environmentDialog_header: "Lobby environment",
    loginDialog_header: "Authorization",
    loginDialog_termsHeader: "Terms of Use",
    loginDialog_policyHeader: "Privacy Policy",
    loginDialog_signUp: "Create account",
    loginDialog_signIn: "Log in",
    loginDialog_inputPlaceholders_email: "Email",
    loginDialog_inputPlaceholders_username: "Username",
    loginDialog_inputPlaceholders_password: "Password",
    loginDialog_authSuccess_signIn: "Log in successful",
    loginDialog_authSuccess_signUp: "Account created",
    loginDialog_userAgreement: `I accept the <rt color="white" hyperlink="https://terms">Terms and Conditions</rt>\nand give my consent to\nSOSOLID INVESTMENTS LIMITED\nto process my personal data\naccording to the <rt color="white" hyperlink="https://policy">Privacy Policy</rt>`,
    loginDialog_validationTexts_email: [
        "Email must be valid email",
        "Email must not exceed 255 characters",
        "Email must not be empty"
    ],
    loginDialog_validationTexts_username: [
        "Username can only contain numbers and letters",
        "Username must not exceed 255 characters",
        "Username must contain at least 4 characters",
        "Username must not be empty",
    ],
    loginDialog_validationTexts_password: [
        "Password must contain at least 3 unique characters",
        "Password must not contain more then 3 consecutive characters",
        "Password must not contain invalid characters",
        "Password must not contain whitespace",
        "Password must not exceed 255 characters",
        "Password must be at least 5 characters long",
        "Password must not be empty",
    ],
    loginDialog_validationTexts_passwordSpecial_containsUsername: "Password must not contain username",
    loginDialog_validationTexts_passwordSpecial_containsEmail: "Password must not contain email",
};
export let text = JSON.parse(JSON.stringify(defaultText));
export async function overloadTextResourcesAsync(partnerSpecificTextsUrl) {
    let partnerSpecificTextResources = {};
    if (partnerSpecificTextsUrl !== undefined) {
        try {
            const response = await fetch(partnerSpecificTextsUrl);
            partnerSpecificTextResources = await response.json();
        }
        catch (e) {
            console.warn(e);
        }
    }
    text = Object.assign({}, defaultText, partnerSpecificTextResources);
}
